<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <marca-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import MarcaCrud from "./MarcaCrud";
    export default {
        name: "Marca",
        components: {MarcaCrud}
    }
</script>

<style scoped>

</style>

